import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { ProductScreenshot } from 'components/ProductScreenshot';
import JSInstallWeb from "../../integrate/_snippets/install-web.mdx";
export const EnableSessionReplayDark = "https://res.cloudinary.com/dmukukwp6/image/upload/posthog.com/contents/images/docs/session-replay/enable-session-replay-in-project-settings-dark-mode.png";
export const EnableSessionReplayLight = "https://res.cloudinary.com/dmukukwp6/image/upload/posthog.com/contents/images/docs/session-replay/enable-session-replay-in-project-settings-light-mode.png";
export const _frontmatter = {};
const layoutProps = {
  EnableSessionReplayDark,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "step-one-install-our-javascript-web-library"
    }}>{`Step one: Install our JavaScript web library`}</h2>
    <p>{`If you already have our JavaScript library or snippet installed, you can skip this step.`}</p>

    <JSInstallWeb mdxType="JSInstallWeb" />
    <h2 {...{
      "id": "step-two-enable-session-recordings-in-your-project-settings"
    }}>{`Step two: Enable session recordings in your project settings`}</h2>
    <p>{`Enable session recordings in your PostHog `}<a parentName="p" {...{
        "href": "https://app.posthog.com/project/settings"
      }}>{`Project Settings`}</a>{`.`}</p>
    <ProductScreenshot imageLight={EnableSessionReplayLight} imageDark={EnableSessionReplayDark} alt="Enable session recordings in your PostHog'" classes="rounded" mdxType="ProductScreenshot" />
    <p>{`Once enabled, the library will start recording sessions by default.`}</p>
    <p>{`They can be toggled off in the by setting the `}<inlineCode parentName="p">{`disable_session_recording: true`}</inlineCode>{` flag in the `}<a parentName="p" {...{
        "href": "/docs/libraries/js/config"
      }}>{`config`}</a>{`. `}</p>
    <p>{`Users who `}<a parentName="p" {...{
        "href": "/docs/libraries/js#opt-out-of-data-capture"
      }}>{`opt out`}</a>{` of event capturing will not have their sessions recorded.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note on using Segment's SDK`}</strong>{`: Session Replay does not work if you send data using `}<a parentName="p" {...{
          "href": "/docs/libraries/segment"
        }}>{`Segment's SDK`}</a>{` as this data is not collected. If you use Segment, you may want to add the PostHog library as well – (make sure to only send regular event data from one source).`}</p>
    </blockquote>
    <h2 {...{
      "id": "how-to-ignore-sensitive-elements"
    }}>{`How to ignore sensitive elements`}</h2>
    <p>{`You may want to hide sensitive text or elements in your replays. See our `}<a parentName="p" {...{
        "href": "/docs/session-replay/privacy"
      }}>{`privacy controls`}</a>{` docs for how to do this.`}</p>
    <h2 {...{
      "id": "how-to-record-sessions-across-different-domains"
    }}>{`How to record sessions across different domains`}</h2>
    <p>{`PostHog automatically captures sessions across subdomains (e.g. `}<inlineCode parentName="p">{`posthog.com`}</inlineCode>{` and `}<inlineCode parentName="p">{`us.posthog.com`}</inlineCode>{`), but recording sessions across different domains (e.g. `}<inlineCode parentName="p">{`posthog.com`}</inlineCode>{` and `}<inlineCode parentName="p">{`hogflix.com`}</inlineCode>{`) requires a bit more setup.`}</p>
    <p>{`To do this, you need to pass the `}<inlineCode parentName="p">{`session_id`}</inlineCode>{` from the first domain to the second domain (for example, as a URL parameter). You can get this value by calling `}<inlineCode parentName="p">{`posthog.get_session_id()`}</inlineCode>{`.`}</p>
    <p>{`Below is an example of how this looks like in Next.js:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// first domain
'use client'
import { usePostHog } from '@posthog/react'

export default function FirstDomain() {
  const posthog = usePostHog()
  return (
    <div>
      <h1>Welcome to the first domain</h1>
      <button onClick={
        () => window.location.href = \`https://seconddomain.com/?session_id=\${posthog.get_session_id()}\`
      }>
        Go to the second domain
      </button>
    </div>
  )
}
`}</code></pre>
    <p>{`On the second domain, bootstrap the PostHog initialization using the session ID. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// second domain
'use client'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'
import { useSearchParams } from 'next/navigation'

export function PHProvider({ children }) {
  const searchParams = useSearchParams()
  const sessionID = searchParams.get('session_id')

  if (typeof window !== 'undefined') {
    posthog.init('<ph_project_api_key>', {
      api_host: '<ph_client_api_host>',
      defaults: '<ph_posthog_js_defaults>',
      bootstrap: { sessionID }
    })
  }

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}
`}</code></pre>
    <p>{`With this setup, PostHog tracks the user's session across domains and captures a single, combined replay.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      